import { Trans } from 'react-i18next';

import { StrongText, Text } from '@dreryk/react-components';

type PractitionerUpdatePermissionsModalExitConfirmationProps = {
   readonly practitionerName: string;
   readonly i18nKey: string;
};

export const PractitionerUpdatePermissionsModalExitConfirmation = (
   props: PractitionerUpdatePermissionsModalExitConfirmationProps
): JSX.Element => {
   return (
      <Text testId={'practitionerPermissionsEditExitConfirmationModalContent'}>
         <Trans
            i18nKey={props.i18nKey}
            values={{
               practitionerName: props.practitionerName,
            }}
            components={{ bold: <StrongText testId={'practitionerName'} /> }}
         />
      </Text>
   );
};
